export default __webpack_public_path__ + "static/media/user.5522a9d6.svg";